import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-about-sidebar',
  templateUrl: './about-sidebar.component.html',
  styleUrls: ['./about-sidebar.component.css']
})
export class AboutSidebarComponent implements OnInit {
  isCollapsed: false;
  constructor(
  ) {
  }

  ngOnInit() {    
  }

}
